var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wash-and-care"},[_c('p',{staticClass:"text-center w-100 fs-6"},[_vm._v(" "+_vm._s(_vm.textDataWash.toLowerCase().replace(/^\w/, d => d.toUpperCase()))+" ")]),_c('div',{staticClass:"ms-auto mt-3 me-auto",domProps:{"innerHTML":_vm._s(_vm.dataWash)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }